import type { MilestoneDatesDto } from "../../../../../autogen/bff-api";

export type MilestoneKey =
  | "announcement"
  | "questionDeadline"
  | "bidDeadline"
  | "evaluationStart"
  | "awardDecision"
  | "standstillExpiry"
  | "contractSigning";

export interface MilestoneNode {
  key: MilestoneKey;
  labelKey: string;
  dateField: keyof MilestoneDatesDto;
  editable: boolean;
}

// Dynamic t() keys consumed via node.labelKey — listed so langen extracts them:
// t('Announcement') t('Question deadline') t('Bid deadline') t('Evaluation start') t('Award decision') t('Standstill expiry') t('Contract signing')
export const MILESTONE_NODES: readonly MilestoneNode[] = [
  { key: "announcement", labelKey: "Announcement", dateField: "announcement", editable: true },
  { key: "questionDeadline", labelKey: "Question deadline", dateField: "questionDeadline", editable: true },
  { key: "bidDeadline", labelKey: "Bid deadline", dateField: "bidSubmissionDeadline", editable: true },
  { key: "evaluationStart", labelKey: "Evaluation start", dateField: "evaluationTarget", editable: true },
  { key: "awardDecision", labelKey: "Award decision", dateField: "awardTarget", editable: true },
  { key: "standstillExpiry", labelKey: "Standstill expiry", dateField: "karensDate", editable: false },
  { key: "contractSigning", labelKey: "Contract signing", dateField: "contractSigningTarget", editable: true },
] as const;
